// extracted by mini-css-extract-plugin
export default {"button":"SlideButton_button__Bc47i","leftButton":"SlideButton_leftButton__4-tKp","rightButton":"SlideButton_rightButton__MjqEE"};